import "../../styles/Bienvenida.css";
import React, { useState, useRef,useEffect  } from "react";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";


interface CronometroFechaProps {
  fechaVencimiento: string; // Debe ser una cadena en formato "YYYY-MM-DDTHH:mm:ss" (por ejemplo, "2022-12-31T23:59:59")
  onTiempoAgotadoChange: (nuevoEstado: boolean) => void;
}

const formatTwoDigits = (value: number) => value.toString().padStart(2, '0');

const CronometroFecha: React.FC<CronometroFechaProps> = ({ fechaVencimiento, onTiempoAgotadoChange }) => {
  const fechaVencimientoObj = new Date(fechaVencimiento);
  const [tiempoRestante, setTiempoRestante] = useState<number>(() => {
    const tiempoActual = new Date();
    const diferenciaTiempo = fechaVencimientoObj.getTime() - tiempoActual.getTime();
    return Math.max(0, Math.floor(diferenciaTiempo / 1000));
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (tiempoRestante > 0) {
        setTiempoRestante((tiempo) => tiempo - 1);
      } else {
        clearInterval(intervalId);
        onTiempoAgotadoChange(true);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [tiempoRestante, onTiempoAgotadoChange]);

  const reiniciarCronometro = () => {
    const tiempoActual = new Date();
    const diferenciaTiempo = fechaVencimientoObj.getTime() - tiempoActual.getTime();
    setTiempoRestante(Math.max(0, Math.floor(diferenciaTiempo / 1000)));
  };

  const horas = Math.floor(tiempoRestante / 3600);
  const minutos = Math.floor((tiempoRestante % 3600) / 60);
  const segundos = tiempoRestante % 60;

  return (
      <div className="cronometro-container">
        <div className="tiempo-container">
          <span className="cronometro-text">{formatTwoDigits(horas)}</span>
          <span className="cronometro-text">:</span>
          <span className="cronometro-text">{formatTwoDigits(minutos)}</span>
          <span className="cronometro-text">:</span>
          <span className="cronometro-text">{formatTwoDigits(segundos)}</span>
        </div>
      </div>
  );
};


const Bienvenida = () => {
  const history = useHistory();
  const [seleccion, setSeleccion] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const toast = useRef(null);

  const newUser = (e: any) => {
    setSeleccion(e.target.id.slice(0, -1));
    setIsVisible(true);
  };

  function handleClick() {
    history.push({
      pathname: "/auth/login",
    });
  }
  const [tiempoAgotado, setTiempoAgotado] = useState(false);

  const handleTiempoAgotadoChange = (nuevoEstado: boolean) => {
    if(tiempoAgotado==false){
      setTiempoAgotado(nuevoEstado);
    }else{

       setTiempoAgotado(true)


    }
  };
  return (
      <>
        <div>
          <Toast ref={toast} />
        </div>
        <div className="header flex flex-col">
          <div className="container flex">
            <div className="header-content">
              <h1 className="text-white fw-6 header-title" id="design">
                INSTITUTO SUPERIOR TECNOLÓGICO UNIVERSITARIO DEL AZUAY
              </h1>
              <h1 className="text-white fw-6 header-title" id="dg">
                TALENTO HUMANO
              </h1>
              <p>
                <h1 className="text-white fw-6 header-title" id="innovacion">
                  Bienvenidos a la plataforma de "Recursos Humanos" Del Instituto
                  Universitario Tecnológico del Azuay. Para ingresar deberá ser
                  miembro de la comunidad educativa.
                  <br/>
                  Antes de llenar la información requerida, tómese unos minutos para revisar este pequeño
                  video-tutorial:
                  <a
                      href="https://drive.google.com/drive/folders/1451c1zBF2oJ6AX-yuXErXttuJjUeUG-8?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-style text-red-500"
                  >
                    {' '}Sistema de Talento Humano - Video Tutorial
                  </a>
                </h1>
              </p>

              <div className="btn-groups flex">
                <button
                    type="button"
                    disabled={tiempoAgotado}
                    className="btn-item bg-brown fw-4 ls-2"
                    style={{
                      backgroundColor: "#004E9D",
                      border: "none",
                      color: "white",
                    }}
                    onClick={handleClick}
                >
                  Iniciar Sesión
                </button>
                <button
                    type="button"
                    className="btn-item bg-dark fw-4 ls-2 "
                    style={{
                      backgroundColor: "#E5BB2A",
                      border: "none",
                      color: "white",
                    }}
                    onClick={newUser}
                >
                  Registrarse
                </button>

              </div>
              <div>
                <h1 className="text1">
                  EL SISTEMA SE CERRARA EN:
                </h1>
              </div>
              <div className="cronometro-container">
                <CronometroFecha fechaVencimiento="2024-02-27T10:00:00" onTiempoAgotadoChange={handleTiempoAgotadoChange} />
              </div>
            </div>

          </div>
        </div>

      </>
  );
};

export default Bienvenida;
